import React from "react";
import { RetailMatchMetricLevel } from "../../../../Enums/RetailMatchMetricLevel";
import RetailMatchBreakoutItemBar from "./RetailMatchBreakoutItemBar";
import RetailMatchBreakoutItemWord from "./RetailMatchBreakoutItemWord";

interface IRetailMatchBreakoutItemProps {
  value: number;
  fontSize: number;
  metricLevel: RetailMatchMetricLevel;
}

const RetailMatchBreakoutItem = (props: IRetailMatchBreakoutItemProps) => {
    return (
        <>
            <RetailMatchBreakoutItemWord
                value={props.value}
                fontSize={13}
                metricLevel={props.metricLevel}
            />
            <RetailMatchBreakoutItemBar value={props.value} />
        </>
    );
};

export default RetailMatchBreakoutItem;
